/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AssigneeId,
  CancelMeetingRequest,
  EnrichmentRequest1,
  MapDataFieldRefString,
  MapString,
  MeetingResponse,
  OptionTimeInterval,
  ProspectBookingLimitReset,
  UpdateMeetingRequest,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V3<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "meetings-platform";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Cancel scheduled meeting
   *
   * @name CancelTheMeetingPublicEndpoint
   * @request DELETE:/v3/public/tenant/{tenantId}/meeting/{meetingId}
   */
  cancelTheMeetingPublicEndpoint = (
    tenantId: string,
    meetingId: string,
    data: CancelMeetingRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/public/tenant/${tenantId}/meeting/${meetingId}`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for cancelTheMeetingPublicEndpoint */
  cancelTheMeetingPublicEndpointPathGetter = (tenantId: string, meetingId: string) =>
    this.getServicePath(`/v3/public/tenant/${tenantId}/meeting/${meetingId}`);

  /**
   * @description Returns a MeetingId if the request was accepted and Error otherwise
   *
   * @name UpdateAMeetingPublicEndpoint
   * @request PATCH:/v3/public/tenant/{tenantId}/meeting/{meetingId}
   */
  updateAMeetingPublicEndpoint = (
    tenantId: string,
    meetingId: string,
    data: UpdateMeetingRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingResponse,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/public/tenant/${tenantId}/meeting/${meetingId}`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateAMeetingPublicEndpoint */
  updateAMeetingPublicEndpointPathGetter = (tenantId: string, meetingId: string) =>
    this.getServicePath(`/v3/public/tenant/${tenantId}/meeting/${meetingId}`);

  /**
   * @description Returns the start and end time of the current cycle of the prospect booking limit
   *
   * @name GetCurrentCycleOfProspectBookingLimitConfig
   * @request PUT:/v3/tenant/{tenantId}/prospect-booking-limit/current-cycle
   * @secure
   */
  getCurrentCycleOfProspectBookingLimitConfig = (
    tenantId: string,
    data: ProspectBookingLimitReset,
    params: RequestParams = {},
  ) =>
    this.request<
      OptionTimeInterval,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/prospect-booking-limit/current-cycle`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getCurrentCycleOfProspectBookingLimitConfig */
  getCurrentCycleOfProspectBookingLimitConfigPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/prospect-booking-limit/current-cycle`);

  /**
   * @description Returns a list of known CRM values depending on configured mappings
   *
   * @name FindAnyKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi
   * @request PUT:/v3/tenant/{tenantId}/enrichment/find-any-crm-values
   * @secure
   */
  findAnyKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi = (
    tenantId: string,
    data: EnrichmentRequest1,
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataFieldRefString,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/enrichment/find-any-crm-values`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAnyKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi */
  findAnyKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApiPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/enrichment/find-any-crm-values`);

  /**
   * @description Returns a list of known CRM values depending on configured mappings
   *
   * @name FindKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi
   * @request PUT:/v3/tenant/{tenantId}/enrichment/find-enrichment-data
   * @secure
   */
  findKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi = (
    tenantId: string,
    data: EnrichmentRequest1,
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataFieldRefString,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/enrichment/find-enrichment-data`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApi */
  findKnownCrmValuesAmongAllKnownSourcesSecuredEnrichmentApiPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/enrichment/find-enrichment-data`);
}
